export interface PlaceholderModuleViewProps {
  label: string;
  onBack: () => void;
}

/**
 * Generic "not implemented yet" view for modules with no defined business
 * logic (Security Tooling, Authentication, Authorization, Supplier
 * Agreements). Ported from view2.js's renderPlaceholderViewHtml().
 */
export function PlaceholderModuleView({ label, onBack }: PlaceholderModuleViewProps) {
  return (
    <div className="card detail-view-card">
      <div className="detail-view-header">
        <button type="button" className="back-button" onClick={onBack}>
          <span aria-hidden="true">&#8592;</span> Back to Application Modules
        </button>
        <h4 className="detail-view-title">{label}</h4>
      </div>
      <div className="placeholder-view">
        <span className="placeholder-view-icon" aria-hidden="true">
          &#128736;
        </span>
        <p className="placeholder-view-text">
          This module doesn't have any functionality defined yet. It's here
          so the navigation structure exists and can be built out later.
        </p>
      </div>
    </div>
  );
}

export interface NotApplicableModuleViewProps {
  label: string;
  onBack: () => void;
}

/**
 * Shown for Security Summary / Initial Questionnaire when the application's
 * security_impact is <= 2 — per product decision, these two modules are
 * "not applicable" at low impact levels rather than being hidden outright,
 * so the navigation structure stays consistent across every application.
 */
export function NotApplicableModuleView({ label, onBack }: NotApplicableModuleViewProps) {
  return (
    <div className="card detail-view-card">
      <div className="detail-view-header">
        <button type="button" className="back-button" onClick={onBack}>
          <span aria-hidden="true">&#8592;</span> Back to Application Modules
        </button>
        <h4 className="detail-view-title">{label}</h4>
      </div>
      <div className="not-applicable-card">
        <span className="not-applicable-icon" aria-hidden="true">
          &#8416;
        </span>
        <p className="not-applicable-text">
          Not applicable to this application. {label} is only relevant for
          applications with a security impact level above 2.
        </p>
      </div>
    </div>
  );
}
